angular.module('dealerware.web.filters').filter('filterEventType', ['$filter', function($filter: any) {
    return function(event_type: string) {
        if (!event_type) {
            return 'Unknown';
        }

        switch (event_type) {
            case 'ign_off':
                return 'Ignition Off';
            case 'batt_warn':
                return 'Battery Check';
            case 'collision':
                return 'Collision Detected';
            case 'power_cut':
                return 'Device Removed';
            case 'power_off':
                return 'Device Powered Off';
            case 'heartbeat':
                return 'Health Check';
            case 'vin':
                return 'VIN Connected';
            case 'refuel':
                return 'Fuel Check';
            case 'telematics_feed':
                return 'Telematics Feed';
            default:
                event_type = $filter('underscoreless')(event_type);
                event_type = $filter('dashless')(event_type);
                event_type = $filter('titlecase')(event_type);

                return event_type;
        }
    };
}]);
